import { styled } from '@uhg-abyss/web/tools/styled';
import { Flex } from '@uhg-abyss/web/ui/Flex';
import { ModalDialog } from '@uhg-abyss/web/ui/ModalDialog';

import { PSXIcon } from '../PSXIcon';

export const HealthGradesStyled = styled(Flex, {
  flexDirection: 'column',
  color: 'white',
  margin: '20px 0 4px $xs',
});
export const StyledIcon = styled(PSXIcon, {
  height: '37px !important',
});

export const HealthGradesInfoModalStyled = styled(ModalDialog, {
  // This is necessary for AbyssV2 to get the HG modal to display above the Patient Reviews filter dropdown (z-index 2000)
  '&.abyss-modal-base-overlay': {
    zIndex: 3000,
  },
  '&.abyss-modal-base-overlay + div': {
    zIndex: 3001,
  },
});
